import React, {useEffect, useState, useRef, useContext} from "react";
import { Link, useHistory } from "react-router-dom";
import { useTranslate } from 'react-polyglot';

import InputTextField from "../../../../common/InputTextField";
import Button from "@material-ui/core/Button";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { Card } from "@material-ui/core";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import FilterListIcon from '@material-ui/icons/FilterList';

import { ExplorerContext } from "../../ExplorerContext";

import fetchHelperService from "../../../../../services/fetchHelper";

import { Bar } from 'react-chartjs-2';
import moment from 'moment';

function CardTypeEbvStandHelse(props) {
    let history = useHistory();
    const t = useTranslate();

    let explorer = useContext(ExplorerContext);

    let chartRef = useRef();

    const [data, setData] = useState([]);
    const [appliedFilters, setAppliedFilters] = useState([]);

    const [filterMin, setFilterMin] = useState(50);
    const [filterMax, setFilterMax] = useState(150);

    const [filteringOpen, setFilteringOpen] = useState(false);

    //const [showAll, setShowAll] = useState(false);

    function fetchData() {
        if (props.onChangeStart != undefined) props.onChangeStart();
        fetchHelperService.fetchRetry("/dataapi/api/dogs/filter/carddata/ebvstandhelsedist", 2000, 3, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json"
            }),
            body: JSON.stringify({
                filters: explorer.filters != undefined ? explorer.filters.filter(i => i.type != "regnumber") : [],
                type: props.examtype
            }),
        }).then(response => {
            if (response.ok && response.status === 200) return response.json();
        }).then(json => {
            setData(json);
            setAppliedFilters(JSON.parse(JSON.stringify(explorer.filters)));
            if (props.onChange != undefined) props.onChange();
        }).catch(error => console.error("Error:", error));
    }

    useEffect(() => {
        if (
            JSON.stringify(explorer.filters) != JSON.stringify(appliedFilters)
        ) {
            fetchData();
        }
    }, [explorer.filters, props.examtype]);

    return (
        <Card className="dogexplorer-card-ebvstandhelse">
            <h1>{t("dogexplorer.statistics.cards.ebvstandhealth.description")}</h1>
            <div>
                <Bar
                    ref={chartRef}
                    chartId="barchart1-1"
                    options={{
                        tooltips: {
                            intersect: false
                        },
                        scales: {
                            xAxes: [
                                {
                                    min: 50,
                                    max: 150,
                                    scaleLabel: {
                                        display: true,
                                        labelString: t("dogexplorer.statistics.cards.ebvrelationshipstand.score")
                                    }
                                }
                            ],
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: true
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: t("dogexplorer.statistics.cards.ebvrelationshipstand.numberofdogs")
                                    }
                                }
                            ]
                        }
                    }}
                    data={{
                        labels: data != undefined ? data.slice(50, 150).map((val, key) => key + 50) : [],
                        datasets: [
                            {
                                backgroundColor: "#382e92",
                                label: t("dogexplorer.statistics.cards.ebvrelationshipstand.number"),
                                data: data != undefined ? data.slice(50, 150) : []
                            }
                        ]
                    }}
                    maxWidth={50}
                    maxHeight={50}
                    //redraw={true}
                ></Bar>
            </div>
            <p onClick={() => setFilteringOpen(!filteringOpen)} style={{ cursor: "pointer" }}>Filter <FilterListIcon></FilterListIcon></p>
            
            <div style={ filteringOpen ? { height: "auto" } : { height: "0px", overflow: "hidden" }}>
                <InputTextField
                    inputProps={{ style: { color: "#000000" } }}
                    InputLabelProps={{ classes: { root: "registration-text" } }}
                    id="filtermin"
                    value={filterMin}
                    label={t("dogexplorer.statistics.cards.ebvrelationshipstand.resultover")}
                    placeholder="0"
                    onChange={(evt) => setFilterMin(evt.target.value)}
                />
                <InputTextField
                    inputProps={{ style: { color: "#000000" } }}
                    InputLabelProps={{ classes: { root: "registration-text" } }}
                    id="filtermax"
                    value={filterMax}
                    label={t("dogexplorer.statistics.cards.ebvrelationshipstand.resultunder")}
                    placeholder="0"
                    onChange={(evt) => setFilterMax(evt.target.value)}
                />
                <Button
                    style={{ width: "auto" }}
                    classes={{ root: "edit-button" }}
                    onClick={() => {
                        let filters = explorer.filters;

                        filters = filters.filter(i => i.type != "helse.ebvstand");

                        if (filterMin != 50) {
                            filters.push({ type: "helse.ebvstand", stage: "pre", operation: "gt", value: Number(filterMin) });
                        }
                        if (filterMax != 150) {
                            filters.push({ type: "helse.ebvstand", stage: "pre", operation: "lt", value: Number(filterMax) });
                        }

                        explorer.updateFilters(filters);
                    }}
                >
                     {t("dogexplorer.statistics.cards.ebvrelationshipstand.addfilter")}
                </Button>
                {/*<div style={{width: "100%"}}>
                    <FormControlLabel
                        control={<Checkbox checked={Boolean(showAll)} onChange={(evt) => setShowAll(evt.target.checked)} />}
                        label="Vis alle resultater for hundene"
                    />
                </div>*/}
            </div>
        </Card>
    );
}

export default CardTypeEbvStandHelse;